import { useInjection } from "inversify-react";
import {useCallback, useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import { ProductStatisticsApi, ProductStatisticsDto } from "../../api";
import ProductStatisticsList from "./productStatisticsList";
import ProductStatisticsModalFormAddContainer from "./productStatisticsModalForm/productStatisticsModalFormContainer";

import Title from "antd/es/typography/Title";
import {useParams} from "react-router-dom";

export default function ProductStatisticsListContainer() {
    const apiService = useInjection(ApiService);
    const [productStatistics, setProductStatistics] = useState<ProductStatisticsDto[] | null>();
    const [isAddFormVisible, setAddFormVisible] = useState(false);
    const [productStatisticsModalFormContainerTitle, setProductStatisticsModalFormContainerTitle] = useState<string>();
    const [idProductStatisticsToEdit, setIdProductStatisticsToEdit] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>();
    let {productId} = useParams();

    const refreshProductStatisticsList = useCallback(async () => {
        setIsLoading(true);
        try {
            const productStatistics = await apiService.getApi(ProductStatisticsApi).apiProductStatisticsProductStatisticsProductIdGet(+productId!);
            setProductStatistics(productStatistics.data);
        } catch (e: any) {
            console.log(e.response.data);
        } finally {
             setIsLoading(false);
         }
    }, [apiService, productId]);

    const onAddClicked = () => {
        setProductStatisticsModalFormContainerTitle("Dodaj nową statystykę");
        setIdProductStatisticsToEdit(null);
        setAddFormVisible(true);
    }

    const onEditClicked = (id: number) => {
        setProductStatisticsModalFormContainerTitle(`Edytuj statystykę o id: ${id}`);

        setIsLoading(true);
        setIdProductStatisticsToEdit(id);
        setAddFormVisible(true);
    }

    const onDeleteClicked = async (id: number) => {
        const response = await apiService.getApi(ProductStatisticsApi).apiProductStatisticsIdDelete(id)

        if (response.request.status !== 200) {
                console.log("Wystąpił błąd podczas usuwania danych");
        } else {
            refreshProductStatisticsList();
        }
    }

    const onFinish = async (shouldRefresh: boolean) => {

        setAddFormVisible(false);

        if (shouldRefresh) {
            refreshProductStatisticsList();
        } else {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        refreshProductStatisticsList();
    }, [refreshProductStatisticsList]);

    return <div style={{marginTop:30}}>
        <Title>Statystyki: </Title>
        <ProductStatisticsList
            data={productStatistics || null}
            onAddClicked={onAddClicked}
            onEditClicked={onEditClicked}
            onDeleteClicked={onDeleteClicked}
            isLoading={isLoading}
        />
        <ProductStatisticsModalFormAddContainer
            onFinish={onFinish}
            id={idProductStatisticsToEdit}
            addFormVisibility={isAddFormVisible}
            title={productStatisticsModalFormContainerTitle || ""}
        />
    </div>
}
